<template>
  <v-dialog v-model="dialog" persistent width="1500">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id_item ? "edit" : "add" }}</v-icon>
          {{ form.id_item ? "Modificar Item" : "Crear Item" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container class="p-0" grid-list-md style="min-width: 97%">
            <v-layout wrap row>
              <v-flex xs12 md6>
                <v-text-field
                  label="Nro ítem"
                  v-model="form.nro_item"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  :items="puestos"
                  item-value="id"
                  item-text="denominacion"
                  name="denominacion"
                  label="Seleccionar puesto"
                  v-model="form.id_puesto"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  :items="cargos"
                  item-value="id"
                  item-text="denominacion"
                  name="denominacion"
                  label="Seleccionar cargo"
                  v-model="form.id_cargo"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  :items="unidades"
                  item-value="id"
                  item-text="nombre_unidad"
                  name="nombre_unidad"
                  label="Seleccionar dependencia"
                  v-model="form.id_unidad"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  :items="listado_items"
                  item-value="id"
                  item-text="nro_item"
                  name="nro_item"
                  label="Seleccionar dependencia de nro item"
                  v-model="form.id_item_padre"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      puestos: [],
      cargos: [],
      unidades: [],
      listado_items: [],
    };
  },
  async mounted() {
    this.$bus.$on("openDialogCrearActualizarItems", async (item) => {
      this.form = item;
     // this.form.id_item_dependiente = item.id_item_padre;
      await this.cargarPuestos();
      await this.cargarCargos();
      await this.cargarUnidades();
      await this.cargarItems();
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.form = {}
      this.loading = false
      this.valid = false;
      this.$bus.$emit("closeDialogCrearActualizarItems");
      this.dialog = false;
    },
    async cargarItems(){
      try {
        let respuesta = await this.$service.graphql({
          query: `query{
                      runQuery(consulta:"select * from movilidad.item vl where vl.id_estado<> '2' order by vl.nro_item asc"){
                        respuesta
                      }
                    }
                  `,
        });
        this.listado_items = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarPuestos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `query{
                      runQuery(consulta:"select * from movilidad.puesto vl where vl.id_estado<>2 order by vl.denominacion asc"){
                        respuesta
                      }
                    }
                  `,
        });
        this.puestos = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },

    async cargarCargos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `query{
                      runQuery(consulta:"select * from movilidad.cargo vl where vl.id_estado<>2 order by vl.denominacion asc"){
                        respuesta
                      }
                    }
                  `,
        });
        this.cargos = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarUnidades() {
      try {
        let respuesta = await this.$service.graphql({
          query: `query{
                      runQuery(consulta:"select * from movilidad.unidad vl  where vl.id_estado=17 and vl.id_entidad =35 order by vl.nombre_unidad asc"){
                        respuesta
                      }
                    }
                  `,
        });
        this.unidades = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let user = this.$storage.get("user");
        try {

          ///////////////MODIFICACION O ALMACENAMIENTO DEL REGISTRO
          if (this.form.id_item) {
            //edito item
            let respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"select movilidad.fn_actualiza_item(${parseInt(
                    this.form.id_item
                  )} ,'${this.form.nro_item}',${parseInt(this.form.id_unidad)},${parseInt(this.form.id_cargo)},${parseInt(this.form.id_puesto)},${parseInt(user.id)},${parseInt(this.form.id_item_padre)})"){
                    respuesta
                  }
                }
              `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_actualiza_item.split("|");
            if (respuesta[0] == "1") {
              this.$message.success("Registro modificado exitosamente");
            } else {
              this.$message.warning(respuesta[1]);
            }
          } else {
            //creo nuevo item
            let respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"select movilidad.fn_registrar_item('${
                    this.form.nro_item
                  }',${this.form.id_unidad},${this.form.id_cargo},${this.form.id_puesto},${parseInt(user.id)},${parseInt(this.form.id_item_padre)})"){
                    respuesta
                  }
                }
              `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_registrar_item.split("|");
            if (respuesta[0] == "1") {
              this.$message.success("Registro creado exitosamente");
            } else {
              this.$message.warning(respuesta[1]);
            }
          }
        } catch (error) {
          console.log(error);
        }

        this.loading = false;
        this.close();
      }
    },
  },
};
</script>
  
  <style>
</style>
  


// WEBPACK FOOTER //
// src/components/admin/item_cargo_y_puesto/dialogs/CrearActualizarItems.vue